import { QueryStatus } from '@reduxjs/toolkit/dist/query';
export var apiBaseEndpoint = '/smartparking/v1.0/';
export var apiRegistrationUrlDomain = '/vehicle/region';
export var apiRegistrationUrlSubString = 'registration';
export var apiRegistrationAdminUrlSubString = 'registration/admin';
export var carpoolApiBaseUrl = 'carpool/region/';
export var carpoolApiCreategroupUrl = '/registration';
export var carpoolApiCreategroupUrlAdmin = '/registration/admin';
export var configDomain = 'config/region/';
export var configEndpoint = '?label=WebUI';
export var emailApiBaseUrl = 'email/region/';
export var sliceName = {
    userSliceName: 'authUser',
    tokenSliceName: 'authToken',
    tokenSmartParkingSliceName: 'smartParkingToken',
    ownerDetailSliceName: 'ownerDetails',
    vehicleDetailSliceName: 'vehicleDetails',
    registerVehicleSliceName: 'registervehicle',
    registerVehicleErrorSliceName: 'registervehicleError',
    formStateSliceName: 'formState',
    carpoolSliceName: 'Carpool',
    carpoolErrorSliceName: 'CarpoolError',
    carpoolCheckedSliceName: 'CarpoolChecked',
    infoBadgeSliceName: 'infoBadge',
    carpoolIsErrorSliceName: 'IsCarpoolError',
    registrationIdSliceName: 'registrationId',
    vehicleRegistrationSliceName: 'vehicleRegistration',
    emailDetailSliceName: 'email',
    environmentSliceName: 'environment',
    configSliceName: 'config',
    chaufferSliceName: 'chaufferDetails',
    regionSliceName: 'region',
};
export var ConfigKey;
(function (ConfigKey) {
})(ConfigKey || (ConfigKey = {}));
export var queryStatus = {
    Fulfilled: QueryStatus.fulfilled,
    Pending: QueryStatus.pending,
    Rejected: QueryStatus.rejected,
    Uninitialized: QueryStatus.uninitialized,
};
